<template>
  <div class="multi-disease-info">
    <div class="title">
      {{ title }}
      <span class="hint">请按复诊药品提供对应信息，以便于医生为您诊断开方</span>
    </div>
    <diseaseBox
      ref="diseaseBox"
      v-for="(item, i) in adaptDrugsSymptomsAndIllnesses"
      :key="item.drugId"
      :name="item.drugId ? `药品${i + 1}：${item.name}` : '请选择药品'"
      :drugId="item.drugId"
      :originSymptoms="item.symptoms"
      :originIllnesses="item.illnesses"
      :hasCustomTag="!isHighRis"
    />
  </div>
</template>

<script>
import diseaseBox from './diseaseBox';

export default {
  name: 'multiDiseaseInfo',
  components: { diseaseBox },
  props: {
    title: {
      type: String
    },
    drugsSymptomsAndIllnesses: {
      type: Array,
      default: () => [{}]
    },
    isHighRis: {
      type: Boolean
    }
  },
  computed: {
    adaptDrugsSymptomsAndIllnesses() {
      if (this.drugsSymptomsAndIllnesses?.length > 0) {
        return this.drugsSymptomsAndIllnesses.map(({ illnesses, symptoms, ...rest }) => {
          return { illnesses: illnesses.map(o => ({ text: o })), symptoms: symptoms.map(o => ({ text: o })), ...rest };
        });
      } else {
        return [{}];
      }
    }
  },
  methods: {
    checkForms() {
      return new Promise(resolve => {
        let result = [];

        this.$refs.diseaseBox.forEach(ref => {
          const diseaseBox = ref.$refs;
          diseaseBox.form?.validate(valid => {
            if (valid) {
              result.push({ info: ref.form, drugId: ref.drugId });
            } else {
              result.push(false);
            }
          });
        });

        resolve({ infos: result, valid: result.every(o => !!o) });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.multi-disease-info {
  margin-bottom: 20px;
  width: 90%;

  .title {
    margin-bottom: 11px;
    color: #242424;
    font-size: 16px;
    font-weight: bold;

    .hint {
      font-size: 14px;
      color: #8c8c8c;
      font-weight: normal;
    }
  }
}
</style>
